import { useEffect, useState } from 'react'
import { Box, Checkbox, TextField, Typography } from '@mui/material'

export default function NutritionPlacard({products, servingSizeLabels = [], servingSizeQuantities = [], servingSizeUnit = 'FL OZ', isDownloading = false}) {

  const styles = {
    placard: {
      fontFamily: '"Arial Narrow", Arial, sans-serif',
      fontWeight: '900',
      maxWidth: '700px',
    },
    productsTable: {
      border: 'none',
      textAlign: "center",
      width: "610px",
    },
    placardHeaderImg: {
      width: "100%",
      margin: 0,
      padding: 0,
      display: 'block',
    },
    placardFooterImg: {
      width: "100%",
    },
    productsTableSmallContainer: {
      paddingTop: "10px",
      paddingLeft: "25px",
      textAlign: "center",
      border: "none",
      backgroundSize: "700px 1px",
      backgroundRepeat: 'repeat-y',
      minHeight: "306px",
      width: "700px",
    },
    productsTableContainer: {
      paddingLeft: "45px",
      textAlign: "center",
      border: "none",
      backgroundSize: "700px 1px",
      backgroundRepeat: 'repeat-y',
      minHeight: "306px",
      width: "700px",      
    },
    tableCell: {
      textAlign: 'right',
      fontFamily: '"Arial Narrow", Arial, sans-serif',
      fontWeight: 900,
      fontStretch: 'narrower',
      lineHeight: '1.10em',
      border: 'none'
    },
    placardTbodyTd: {
      borderBottom: "1px solid black",
      fontWeight: 100,
      fontStretch: "condensed",
      fontSize: "100%",
      maxWidth: "17%",
      marginBottom: 0,
      textAlign: "center",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
    },    
    placardHeader: {
      width: "700px",
      padding: 0,
      margin: 0,
    },
    placardFooter: {
      width: "700px",
      padding: 0,
      margin: 0,
    },    
    placardRowName: {
      textAlign: "left",
    },
    placardRowData: {
      textAlign: "right",
      paddingRight: "4px",
      height: "34px",
    }
  };

  const [showHeaderAndFooter, setShowHeaderAndFooter] = useState(true);
  const [tableBody, setTableBody] = useState(<></>);
  const [productsMap, setProductsMap] = useState({});

  const handleProductNameChange = (e) => {
    const { id, value } = e.target
    
    setProductsMap((prev) => ({
      ...prev, 
      [id]: {...prev[id], name: value},
    }))
  }

  useEffect(() => {
    if(products?.length) {
      
      const productsMap = products.reduce((map, product) => {
        if(product?.ID) {
          let p = map[product.ID]
          if(!p) {
            p = {
              id: product.ID,
              name: product['Product Name'],
              sizes: []
            }
          }
          p.sizes.push({
            size: product[`(${servingSizeUnit})`],
            calories: `${product['Calories (Cal)']} Cal`
          })
          map[product.ID] = p
        }
        return map
      }, {})
      setProductsMap(productsMap)
    }
  }, [products, servingSizeUnit])

  const handleChange = (event) => {
    setShowHeaderAndFooter(event.target.checked)
  }

  useEffect(() => {
    const _products = Object.values(productsMap)
    if(_products.length) {
      const _tableBody = _products.slice(0, 10).map((p, idx) => {
        let sizes = p.sizes?.length ? p.sizes.slice(0, 3) : []
        let html = (
          <tr key={"rowName" + p.id}>
            <td style={{...styles.placardTbodyTd, ...styles.placardRowName }}>
              {isDownloading ? <span>{p.name}</span> : 
              <TextField
                fullWidth
                id={p.id}
                className='placard_input'
                value={p.name}
                onChange={(e) => { e.target.index = idx; handleProductNameChange(e) }}
                variant="outlined"
              />}
            </td>
            {sizes.slice(0, 3).map(size => {
              return <td style={{...styles.placardTbodyTd, ...styles.placardRowData, width: '15%'}} key={`rowSize|${p.id}|${size.size}`}>{size.calories}</td>
            })}
          </tr>
        )
        return html;
      });
      setTableBody(_tableBody)
    }
  }, [productsMap, isDownloading])

  const imageDomain = `https://s3.amazonaws.com/nutrition-calculator.tis.coke.com/static/media`
  let tableHeader = '';
  if (showHeaderAndFooter) {
    tableHeader = <img src={`${imageDomain}/placard-header.png`} style={styles.placardHeaderImg}></img>
  }
  let tableFooter = <img src={showHeaderAndFooter ? `${imageDomain}/placard-footer2.png` : `${imageDomain}/placardsmallfooter.png`} style={styles.placardFooterImg}></img>

  if(productsMap && servingSizeLabels?.length && servingSizeQuantities?.length) {
    const labels = servingSizeLabels.filter(s => s !== null && s !== undefined && s.length).slice(0, 3)
    const quantities = servingSizeQuantities.filter(s => s !== null && s !== undefined && s.length).slice(0, 3)
    const uom = servingSizeUnit === 'fl-oz' ? 'FL OZ' : servingSizeUnit.toUpperCase()
  
    const _products = Object.values(productsMap)
    if(_products.length) {
      let tableSizes = []
      if(servingSizeLabels?.length) {
        tableSizes = labels.map((label, idx) => {
          return label?.length ? <td style={{ ...styles.tableCell, width: '15%'}}>{label}<br />{quantities[idx]} {uom}</td> : <></>
        })
      }
      const containerSx = showHeaderAndFooter ? {
        ...styles.productsTableContainer,
        backgroundImage: `url(${imageDomain}/placard-bg.png)`,
        
      } : {
        ...styles.productsTableSmallContainer,
        backgroundImage: `url(${imageDomain}/placardsmallbg.png)`,
        
      }

      return (
        <>
          
          <Box>
            <Typography sx={{fontStyle: 'italic', color: '#999', fontSize: '14px'}}>Please note that due to size and space restrictions on a Nutrition Placard, there is a maximum of three serving sizes and ten products shown.</Typography>
            <Typography component="span">Show Header and Footer?</Typography> <Checkbox id="showHeaderAndFooter" checked={showHeaderAndFooter} onChange={(e) => handleChange(e)}></Checkbox><br/>
            <Box id={isDownloading ? 'placard' : ''} style={styles.placard}>
              {tableHeader}
              <Box id={showHeaderAndFooter ? 'productsTableContainer' : 'productsTableSmallContainer'} style={containerSx}>
                <table style={styles.productsTable}>
                  <tbody>
                    <tr>
                      <td style={{ ...styles.tableCell, width: `${100 - (15 * tableSizes.length)}%`}}></td>
                      {tableSizes}
                    </tr>
                    {tableBody}
                  </tbody>
                </table>
              </Box>
              {tableFooter}
            </Box>
          </Box>
        </>
      );
    }
  }
  return <></>
}